/* eslint-disable max-len */
import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';

import {NotificationStatusEnum} from '../enums/notification-types.enum';
import {NotificationFilter} from '../models/base-notification.model';
import {FacultyNotificationWithLink} from '../models/request-response-notification.models';

@Injectable({
    providedIn: 'root'
})
export class NotificationContextService {
    private contextSelectedFilters = new ReplaySubject<NotificationFilter[]>(1);
    private contextNotificationStatusChanged = new ReplaySubject<{
        notification: FacultyNotificationWithLink;
        newStatus: NotificationStatusEnum;
    }>(1);

    contextSelectedFilters$ = this.contextSelectedFilters.asObservable();
    contextNotificationStatusChanged$ = this.contextNotificationStatusChanged.asObservable();

    constructor() {}

    setNotificationFilters(filters: NotificationFilter[]): void {
        this.contextSelectedFilters.next(filters);
    }

    setNotificationStatusChanged(notification: FacultyNotificationWithLink, newStatus: NotificationStatusEnum): void {
        this.contextNotificationStatusChanged.next({notification, newStatus});
    }
}
